$(document).ready(function () {

    blueimp.Gallery.prototype.options.titleElement = '.title';
    blueimp.Gallery.prototype.options.slideshowInterval = 5000;
    blueimp.Gallery.prototype.options.transitionSpeed = 400;

});